export default function PixelArrow(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="12"
			height="20"
			viewBox="0 0 12 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect width="4" height="4" fill="currentColor" />
			<rect x="4" y="4" width="4" height="4" fill="currentColor" />
			<rect x="8" y="8" width="4" height="4" fill="currentColor" />
			<rect x="4" y="12" width="4" height="4" fill="currentColor" />
			<rect y="16" width="4" height="4" fill="currentColor" />
		</svg>
	)
}
